var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "Stockreport "
  }, [_c('loader', {
    attrs: {
      "isLoading": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 mb-1"
  }, [_c('b-tabs', [_c('b-tab', {
    staticClass: "show",
    attrs: {
      "title": _vm.$t('unicommerce.unicomminventory.unicommInvCompTitle'),
      "active": ""
    },
    on: {
      "click": function($event) {
        _vm.loadReport('inventry')
      }
    }
  }, [(_vm.Status == 'inventry') ? _c('div', [_c('div', {
    staticClass: "card-headerfrmOrd"
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [(_vm.showSelectClient || _vm.showSelectWarehouse) ? _c('div', {
    staticClass: "form-group row"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.clientProductId')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-cube'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('product.clientProductIdPlaceHolder')
    },
    model: {
      value: (_vm.ClientProductID),
      callback: function($$v) {
        _vm.ClientProductID = $$v
      },
      expression: "ClientProductID"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('product.productId')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-cube'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.productIdPlaceHolder')
    },
    model: {
      value: (_vm.ProductID),
      callback: function($$v) {
        _vm.ProductID = $$v
      },
      expression: "ProductID"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "28px",
      "margin-left": "30px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.getCancelPutawayReportDataSearch()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" " + _vm._s(_vm.$t('common.searchBtn')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetSearchForm
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('common.resetBtn')))])])])])])])], 1)]) : _vm._e()]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": _vm.$t('unicommerce.unicomminventory.getPassTitle')
    },
    on: {
      "click": function($event) {
        _vm.loadReport('getpass')
      }
    }
  }, [(_vm.Status == 'getpass') ? _c('div', [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('unicommerce.unicomminventory.getPassNo')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-cube'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('unicommerce.unicomminventory.getPassNoPlaceholder')
    },
    model: {
      value: (_vm.getpass),
      callback: function($$v) {
        _vm.getpass = $$v
      },
      expression: "getpass"
    }
  })], 1), _vm._v(" "), (_vm.getpass == '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.getpassErr))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "28px",
      "margin-left": "30px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.getpassApi()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" " + _vm._s(_vm.$t('common.searchBtn')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetSearchForm
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('common.resetBtn')))])])])])])])], 1) : _vm._e()]), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": _vm.$t('unicommerce.unicomminventory.fcinventorytitle')
    },
    on: {
      "click": function($event) {
        _vm.loadReport('fcinventry')
      }
    }
  }, [(_vm.Status == 'fcinventry') ? _c('div', [_c('div', {
    staticClass: "card-headerfrmOrd"
  }, [_c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.clientProductId')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-cube'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('product.clientProductIdPlaceHolder')
    },
    model: {
      value: (_vm.FCClientProductID),
      callback: function($$v) {
        _vm.FCClientProductID = $$v
      },
      expression: "FCClientProductID"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('product.productId')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-cube'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.productIdPlaceHolder')
    },
    model: {
      value: (_vm.FCProductID),
      callback: function($$v) {
        _vm.FCProductID = $$v
      },
      expression: "FCProductID"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('common.rackID')))]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa  fa-cube'></i>"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('common.rackIDPlaceholder')
    },
    model: {
      value: (_vm.FCRackID),
      callback: function($$v) {
        _vm.FCRackID = $$v
      },
      expression: "FCRackID"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('unicommerce.unicomminventory.labelmatchedInventory')))]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-window-maximize'></i>"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.matchedinventorydropdown),
      expression: "matchedinventorydropdown"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "matchedinventorydropdown"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.matchedinventorydropdown = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v(_vm._s(_vm.$t('unicommerce.unicomminventory.labelmatchedInventory')))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "matched"
    }
  }, [_vm._v("matched")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "diff"
    }
  }, [_vm._v("Unmatched")])])]), _vm._v(" "), (_vm.matchedinventorydropdown == '') ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.labeltypeErr))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "float-right",
    staticStyle: {
      "margin-top": "28px",
      "margin-left": "30px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.getCancelPutawayReportDataFC()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" " + _vm._s(_vm.$t('common.searchBtn')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetSearchForm
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" " + _vm._s(_vm.$t('common.resetBtn')))])])])])])], 1)]) : _vm._e()])], 1)], 1)]), _vm._v(" "), (_vm.Status == 'inventry') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm"
  }, [_c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "height": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-3 cardlistheader"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('unicommerce.unicomminventory.unicommInvCompTitle')) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 cardlistheader"
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('common.table.heading')) + " - " + _vm._s(this.formattedDate))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1,5 "
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy",
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('common.table.count')) + " - " + _vm._s(this.totalRows))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-0.5 cardlistheader"
  }, [_c('loader', {
    staticStyle: {
      "margin-right": "-400px"
    },
    attrs: {
      "isLoading": _vm.isLoadingforxls
    }
  })], 1), _vm._v(" "), (_vm.download && _vm.listcancelunicomInventoryReportData.length > 0) ? _c('div', {
    staticClass: "col-md-1"
  }, [_c('button', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-left": "174px",
      "margin-right": "-200px"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.Choosetype(1)
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.downloadBtn')))])]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.listcancelunicomInventoryReportData.length) ? _c('div', {
    staticClass: "col-md-1"
  }, [(_vm.warehousetype != 'Flipkart Smart') ? _c('button', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "-190px"
    },
    attrs: {
      "title": "Download CSV",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.getCancelPutawayReportData(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })]) : _vm._e(), _vm._v(" "), (_vm.warehousetype == 'Flipkart Smart') ? _c('button', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-right": "-190px"
    },
    attrs: {
      "title": "Download CSV",
      "disabled": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.getCancelPutawayReportDataSmart(1)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-download"
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.show && _vm.listcancelunicomInventoryReportData.length > 0) ? _c('div', {
    staticClass: "col-md-1"
  }, [(_vm.warehousetype != 'Flipkart Smart') ? _c('download-excel', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-left": "174px",
      "margin-right": "-155px"
    },
    attrs: {
      "before-generate": _vm.startDownload,
      "before-finish": _vm.finishDownload,
      "title": "Download Excel",
      "header": _vm.dataFilter2,
      "data": _vm.listReportDataforxls1,
      "fields": _vm.csvFieldsForXls1,
      "worksheet": "MyWorksheet",
      "name": _vm.reportname
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.warehousetype == 'Flipkart Smart') ? _c('download-excel', {
    staticClass: "btn btn-info downloadbutton",
    staticStyle: {
      "margin-left": "174px",
      "margin-right": "-155px"
    },
    attrs: {
      "before-generate": _vm.startDownload,
      "before-finish": _vm.finishDownload,
      "title": "Download Excel",
      "header": _vm.dataFilter2,
      "data": _vm.listReportDataforxls2,
      "fields": _vm.csvFieldsForXls2,
      "worksheet": "MyWorksheet",
      "name": _vm.reportname
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary tablecss"
  }, [_c('td', {
    staticClass: "text-center tablecss",
    attrs: {
      "colspan": "1"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "text-center tablecss",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v(_vm._s(_vm.$t('unicommerce.unicomminventory.unicom')) + " ")]), _vm._v(" "), _c('td', {
    staticClass: "text-center tablecss",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('unicommerce.unicomminventory.wms')))]), _vm._v(" "), _c('td', {
    staticClass: "text-center tablecss",
    attrs: {
      "colspan": "1"
    }
  })]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('common.clientProductId')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('common.eanCode')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('common.productId')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('orders.totalQTY')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('unicommerce.unicomminventory.blockQty')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('orders.pendingQty')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('unicommerce.unicomminventory.uniwarerackid')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('daywiseatpstock.currentstock')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('reports.rackStock')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('common.mrp')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('warehouseRacks.rackId')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listcancelunicomInventoryReportData), function(data) {
    return _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', [_vm._v(_vm._s(data.clientproductid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.eancode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.productid))]), _vm._v(" "), (data.isUnicomm == 1) ? _c('td', [_vm._v(_vm._s(data.inventory))]) : _vm._e(), _vm._v(" "), (data.isUnicomm != 1) ? _c('td', [_vm._v("-")]) : _vm._e(), _vm._v(" "), (data.isUnicomm == 1) ? _c('td', [_vm._v(_vm._s(data.inventoryBlocked))]) : _vm._e(), _vm._v(" "), (data.isUnicomm != 1) ? _c('td', [_vm._v("-")]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.pendingqty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.unicomrackid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.totalqty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.rackqty))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.mrp))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.rackid))])])
  }))])]), _c('br'), _vm._v(" "), (_vm.totalPage && _vm.listcancelunicomInventoryReportData.length > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPage,
      "total": _vm.totalRows,
      "per-page": _vm.pageLimit,
      "current-page": _vm.currentPage
    },
    on: {
      "pagechanged": _vm.onPageChange
    }
  }) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), (_vm.Status == 'fcinventry') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card-headerfrm"
  }, [_c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "height": "20px"
    }
  }, [_c('div', {
    staticClass: "col-md-3 cardlistheader"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t(' FC Inventory Comparison')) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 cardlistheader"
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('common.table.heading')) + " - " + _vm._s(this.formattedDate))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1,5 "
  }, [_c('b', {
    staticStyle: {
      "font-family": "cursive,fantasy",
      "color": "green"
    }
  }, [_c('i', {
    staticClass: "fa fa-time",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(_vm._s(_vm.$t('common.table.count')) + " - " + _vm._s(this.totalRowsFC))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered datatables cardtable"
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary tablecss"
  }, [_c('td', {
    staticClass: "text-center tablecss",
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('unicommerce.unicomminventory.wms')))]), _vm._v(" "), _c('td', {
    staticClass: "text-center tablecss",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v(_vm._s(_vm.$t('unicommerce.unicomminventory.fc')) + " ")])]), _vm._v(" "), _c('tr', {
    staticClass: "text-primary cardreporttablerow"
  }, [_c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('common.clientProductId')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('common.eanCode')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('common.productId')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('common.mrp')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('purchaseOrder.ProductName')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('common.rackID')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('common.quantity')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('common.rackType')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('unicommerce.unicomminventory.fcproductid')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('unicommerce.unicomminventory.fcrackid')))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('unicommerce.unicomminventory.fcquantity')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.listreportfcinventorydata), function(data) {
    return _c('tr', {
      staticClass: "text-center cardreporttabletr"
    }, [_c('td', [_vm._v(_vm._s(data.clientproductid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.eancode))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.productid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.mrp))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.productname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.rackid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.quantity))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.racktype))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.fcproductid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.fcrackid))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.fcquantity))])])
  }))])]), _c('br'), _vm._v(" "), (_vm.totalPageFC && _vm.listreportfcinventorydata.length > 0) ? _c('pagination', {
    attrs: {
      "total-pages": _vm.totalPageFC,
      "total": _vm.totalRowsFC,
      "per-page": 200,
      "current-page": _vm.currentPageFC
    },
    on: {
      "pagechanged": _vm.onPageChangeFC
    }
  }) : _vm._e()], 1)])]) : _vm._e()])], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3931a06f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3931a06f","hasScoped":true}!./src/views/components/reports/unicominventorycomparisonreport/unicominventorycomparisonreport.component.html
// module id = 1853
// module chunks = 0